// extracted by mini-css-extract-plugin
module.exports = {"place-title":"place-title--tMrBO","placeTitle":"place-title--tMrBO"};